/**
 * Gives info about currently screen matching responsive version
 *
 * @author bgr
 * @author tku
 */
import { data } from "../../shared/state/payload";
import { watch as watchResize } from "../../shared/event/resize-observer";

export const SIZE_MOBILE = "mobile";
export const SIZE_TABLET = "tablet";
export const SIZE_DESKTOP = "desktop";
export const SIZE_CINEMA = "cinema";

export const SIZES = [SIZE_MOBILE, SIZE_TABLET, SIZE_DESKTOP, SIZE_CINEMA];

function calculateVersion() {
	const width = document.documentElement.clientWidth;

	for (let index in SIZES) {
		const screenSize = SIZES[index];

		if (data.grid[screenSize] === undefined) {
			continue;
		}

		const minWidth = data.grid[screenSize][0];
		const maxWidth = data.grid[screenSize][1];

		if (minWidth <= width && (width <= maxWidth || maxWidth === null)) {
			return screenSize;
		}
	}
}

/**
 * Returns the version identifier for current screen width
 *
 * @return {string}
 */
let lastVersion = calculateVersion();
export const getVersion = () => lastVersion;

/**
 * Returns true if current screen version is greater or equal to the given one
 *
 * @param {string} minimalVersion
 * @return boolean
 */
export function isAtLeast(minimalVersion) {
	for (const index in SIZES) {
		if (SIZES[index] == minimalVersion) {
			return true;
		}
		if (SIZES[index] == lastVersion) {
			return false;
		}
	}
}

const watchers = new Map();
watchResize(document.body, () => {
	const currentVersion = calculateVersion();
	if (lastVersion !== currentVersion) {
		lastVersion = currentVersion;
		watchers.forEach(callback => callback(currentVersion));
	}
});

/**
 * Observes changes to screen version using defined breakpoints
 */
export function watch(key, callback) {
	watchers.set(key, callback);
}

export function unwatch(key) {
	watchers.delete(key);
}

export function getMinWidth(version) {
	return data.grid[version][0];
}
